import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=3921a7b7&"
import script from "./error-message.vue?vue&type=script&lang=js&"
export * from "./error-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports